import { Badge } from "components/ui";

export function StageDisplay({ stageName, stageId }) {
  // Use stageName directly if provided, otherwise fallback to stageId
  const displayName = stageName || (stageId ? `Stage ${stageId}` : 'No Stage');
  
  return (
    <Badge variant="outline" className="text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-900/20 dark:text-indigo-400">
      {displayName}
    </Badge>
  );
}
